<template>
  <div>
    <div class="tw-relative tw-flex tw-items-center">
      <input
        :value="modelValue"
        @input="update"
        :data-test="testId"
        class="tw-w-full tw-inline-block tw-text-text tw-text-sm tw-py-1 tw-pl-2.5 tw-pr-8 tw-h-8 tw-border tw-border-border tw-bg-background"
      />
      <div class="tw-absolute tw-mr-2.5 tw-flex tw-items-center tw-right-0">
        <button v-if="modelValue" @click="clear" :data-test="`${testId}-clear`">
          <font-awesome-icon icon="fa-regular fa-circle-xmark" class="tw-text-sm" />
        </button>
        <font-awesome-icon v-else icon="fa-regular fa-magnifying-glass" class="tw-text-sm" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavSearch",
  emits: ["update:modelValue"],
  props: {
    modelValue: String,
    testId: {
      type: String,
      default: "search-nav",
    },
  },
  setup(props, { emit }) {
    const clear = () => updateModelValue(null);
    const update = (e) => updateModelValue(e.target.value);
    const updateModelValue = (value) => emit("update:modelValue", value);

    return {
      clear,
      update,
    };
  },
};
</script>
